import React, { FC, useCallback } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import formatPriceNumber from 'utils/formatPrice';
import { openItemModal } from 'data/cacheHelpers/menu';
import ItemStatusSelect from 'components/Form/ItemStatusSelect';
import ItemListImage from 'components/ItemListImage';
// import { normalizeStatus } from 'model/menu';
import {
  Container,
  Fragment,
  TextMedium,
  TextSemi,
  DraggableIcon,
  // TextMenuStatus,
} from './styles';
import { Props } from './types';

const Item: FC<Props> = ({
  index,
  brandId,
  categoryId,
  itemData,
  modifiers,
  isProcessing,
}) => {
  const openEditItem = useCallback(
    () =>
      openItemModal({
        brandId,
        item: {
          ...itemData,
          childrenEntities: modifiers,
          categoryId,
        },
      }),
    [itemData, brandId, modifiers, categoryId],
  );
  return (
    <Draggable
      draggableId={itemData.itemId}
      index={index}
      isDragDisabled={isProcessing}
    >
      {(provided) => (
        <Container
          onClick={openEditItem}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Fragment>
            <ItemListImage src={itemData.imageUrlSmall} alt="" />
          </Fragment>

          <Fragment>
            <TextSemi>{itemData.name.displayName}</TextSemi>
          </Fragment>

          <Fragment>
            <TextMedium>{itemData.name.printName}</TextMedium>
          </Fragment>

          <Fragment>
            <TextMedium>{modifiers.length} modifiers</TextMedium>
          </Fragment>

          <Fragment>
            <TextSemi>{formatPriceNumber(itemData.price)}</TextSemi>
          </Fragment>

          <Fragment>
            <ItemStatusSelect
              brandId={brandId}
              itemId={itemData.itemId}
              value={itemData.status}
            />
            {/* <TextMenuStatus value={itemData.status}>
              {normalizeStatus(itemData.status)}
            </TextMenuStatus> */}
          </Fragment>
          {!isProcessing && <DraggableIcon />}
        </Container>
      )}
    </Draggable>
  );
};

export default Item;
